import React from 'react';
import clsx from 'clsx';
import { IProps } from './FiftyFiftyAccordionBlock.interface';
import './FiftyFiftyAccordionBlock.styles.css';
import BlockWrapper from '@/layouts/BlockWrapper/BlockWrapper.component';
import ContentWrapper from '@/layouts/ContentWrapper/ContentWrapper.component';
import { ContentColumn } from '@/layouts/ContentWrapper/ContentWrapper.component';
import Heading from '@/elements/Heading/Heading.component';
import Accordion from '@/components/Accordion/Accordion.component';
import Image from '@/elements/Image/Image.component';
import Text from '@/elements/Text/Text.component';

const FiftyFiftyAccordionBlock: React.FC<IProps> = ({
    className,
    heading,
    image,
    caption,
    accordionItems,
    mediaPosition = 'right',
    ...blockWrapperProps
}) => {
    const mediaColOrder = clsx({
        'order-2': true, // Image is always second on mobile
        'md:order-1': mediaPosition === 'left',
        'md:order-2': mediaPosition === 'right',
    });

    const textColOrder = clsx({
        'order-1': true, // Text is always first on mobile
        'md:order-2': mediaPosition === 'left',
        'md:order-1': mediaPosition === 'right',
    });

    return (
        <BlockWrapper
            className={clsx('fiftyFiftyAccordionBlock', className)}
            {...blockWrapperProps}
        >
            <ContentWrapper>
                {/* Mobile: Text always first. Desktop: Order based on mediaPosition */}
                <ContentColumn
                    layout="half"
                    className={clsx('fiftyFiftyAccordionBlock__textColumn', textColOrder)}
                >
                    {heading && (
                        <Heading
                            level={2}
                            html={heading}
                            className="fiftyFiftyAccordionBlock__heading"
                        />
                    )}
                    <Accordion items={accordionItems} />
                </ContentColumn>
                <ContentColumn
                    layout="half"
                    className={clsx(
                        'fiftyFiftyAccordionBlock__mediaColumn',
                        mediaColOrder,
                    )}
                >
                    {image && <Image {...image} rounded={true} />}
                    {caption && (
                        <Text html={caption} className="fiftyFiftyAccordionBlock__caption" />
                    )}
                </ContentColumn>
            </ContentWrapper>
        </BlockWrapper>
    );
};

export { FiftyFiftyAccordionBlock };
